import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import './MultiSignalsAlerts.scss';
import { resetAlertAction } from '../../store/alert/alertActions';

// Import modern icons
import { 
  CheckCircle, 
  AlertTriangle, 
  AlertCircle, 
  Info, 
  X,
  Clock
} from 'lucide-react';

const MultiSignalsAlerts = (props) => {
  const { alert } = props;
  const { title, time, variant = 'danger', outTimeMS } = alert;
  let text = alert.text;
  
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (text && text !== '') {
      setIsVisible(true);
      setIsClosing(false);
      
      // Auto close after duration
      const timer = setTimeout(() => {
        handleClose();
      }, outTimeMS || 4000);

      return () => clearTimeout(timer);
    }
  }, [text, outTimeMS]);

  function closeAlerts() {
    props.dispatch(resetAlertAction());
  }

  function handleClose() {
    setIsClosing(true);
    setTimeout(() => {
      setIsVisible(false);
      closeAlerts();
    }, 300); // Animation duration
  }

  // Get icon based on variant
  const getIcon = () => {
    switch (variant) {
      case 'success':
        return <CheckCircle size={20} />;
      case 'warning':
        return <AlertTriangle size={20} />;
      case 'danger':
      case 'error':
        return <AlertCircle size={20} />;
      case 'info':
        return <Info size={20} />;
      default:
        return <Info size={20} />;
    }
  };

  // Get variant colors
  const getVariantClasses = () => {
    switch (variant) {
      case 'success':
        return 'alert-success';
      case 'warning':
        return 'alert-warning';
      case 'danger':
      case 'error':
        return 'alert-danger';
      case 'info':
        return 'alert-info';
      default:
        return 'alert-info';
    }
  };

  if (text === '' || text === undefined || text === null) {
    if (text === undefined || text === null) {
      text = 'Hmm... Something went wrong!';
    } else {
      return <></>;
    }
  }

  if (!isVisible) {
    return <></>;
  }

  return (
    <div className="modern-alerts-container">
      <div 
        className={`modern-alert ${getVariantClasses()} ${isClosing ? 'closing' : 'showing'}`}
      >
        {/* Alert Content */}
        <div className="alert-content">
          {/* Icon */}
          <div className="alert-icon">
            {getIcon()}
          </div>

          {/* Text Content */}
          <div className="alert-text-content">
            {title && (
              <div className="alert-title">
                {title}
                {time && (
                  <div className="alert-time">
                    <Clock size={12} />
                    <span>{time}</span>
                  </div>
                )}
              </div>
            )}
            <div className="alert-message">
              {text}
            </div>
          </div>

          {/* Close Button */}
          <button 
            className="alert-close-btn"
            onClick={handleClose}
            type="button"
          >
            <X size={16} />
          </button>
        </div>

        {/* Progress Bar */}
        <div className="alert-progress-container">
          <div 
            className="alert-progress-bar"
            style={{ 
              animationDuration: `${(outTimeMS || 4000) / 1000}s`,
              animationPlayState: isClosing ? 'paused' : 'running'
            }}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    alert: state.alertReducer.alert,
  };
};

export default connect(mapStateToProps)(MultiSignalsAlerts);